"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGroupedOptions = exports.parseKey = exports.getKey = exports.DisplayTableOption = exports.CellType = void 0;
exports.getCellType = getCellType;
exports.formatValue = formatValue;
var CellType;
(function (CellType) {
    CellType["AttributeHeaderCell"] = "ATTRIBUTE_HEADER_CELL";
    CellType["AttributeHeaderSummaryCell"] = "ATTRIBUTE_HEADER_SUMMARY_CELL";
    CellType["AttributeValueCell"] = "ATTRIBUTE_VALUE_CELL";
    CellType["RegularCell"] = "REGULAR_CELL";
})(CellType || (exports.CellType = CellType = {}));
var DisplayTableOption;
(function (DisplayTableOption) {
    DisplayTableOption["HideEmptyColumns"] = "HIDE_EMPTY_COLUMNS";
    DisplayTableOption["HideEmptyRows"] = "HIDE_EMPTY_ROWS";
})(DisplayTableOption || (exports.DisplayTableOption = DisplayTableOption = {}));
function getCellType(params) {
    var _a, _b;
    // 1) this is our attribute cell
    if (((_a = params.data) === null || _a === void 0 ? void 0 : _a.isSelectedAttributeRow) && params.colDef.field === 'value') {
        return CellType.AttributeHeaderCell;
    }
    // 2) this is our topTotalCount attribute cell
    if (((_b = params.data) === null || _b === void 0 ? void 0 : _b.isSelectedAttributeRow) && params.colDef.field !== 'value') {
        return CellType.AttributeHeaderSummaryCell;
    }
    // 3)  this is our attribute-value cell
    if (params.node.rowIndex > 0 && params.colDef.field === 'value') {
        return CellType.AttributeValueCell;
    }
    // 4) just regular cell
    return CellType.RegularCell;
}
function formatValue(value) {
    return value === 0 ? '-' : value;
}
/** Build the composite key used everywhere in the table */
const getKey = (value, title) => `${value}||${title}`;
exports.getKey = getKey;
/** Reverse of makeKey */
const parseKey = (key) => key.split('||');
exports.parseKey = parseKey;
/** Transform data into grouped options format for selectors */
const createGroupedOptions = (data) => data.map(({ title, id, descendants }) => ({
    label: title,
    value: id,
    children: descendants.edges.map((edge) => ({
        label: edge.node.descendant.title,
        value: edge.node.descendant.id,
    })),
}));
exports.createGroupedOptions = createGroupedOptions;
